import { render } from "./cmf-checkbox.vue?vue&type=template&id=d942a046&scoped=true"
import script from "./cmf-checkbox.vue?vue&type=script&lang=js"
export * from "./cmf-checkbox.vue?vue&type=script&lang=js"

import "./cmf-checkbox.vue?vue&type=style&index=0&id=d942a046&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/academy/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d942a046"]])

export default __exports__